import {GlobalUtility} from '../service/global-utility.service';
import {USER_DETAILS} from '../service/constants.service';

export const formMixins ={
  data(){
    return{
      authUser : JSON.parse(localStorage.getItem(USER_DETAILS)),
    }
  },

  methods:{
    capitalize(e, o ,prop){
      this.$set(o, prop, e.target.value.toUpperCase());
    },

    capitalizeObject(value){
      return GlobalUtility.capitalizeProperties(value);
    },

    decapitalizeObject(value){
      return GlobalUtility.deCapitalizeProperties(value);
    },

  },

  // computed:{},

  // mounted(){},

  // created(){}

};

export default {formMixins}
